import { render } from "./indexEn.vue?vue&type=template&id=17bed052&scoped=true&ts=true"
import script from "./indexEn.vue?vue&type=script&lang=ts"
export * from "./indexEn.vue?vue&type=script&lang=ts"

import "./indexEn.vue?vue&type=style&index=0&id=17bed052&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bed052"]])

export default __exports__